import(/* webpackMode: "eager", webpackExports: ["Hero","WhyAutomation","Industries","CaseStudy","FAQ","FinalCTA"] */ "/app/src/app/[locale]/solutions/automatisation/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/data.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/roadmap.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/training.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/workflow.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/automation-services-client.tsx");
